import React from "react";
import { connect } from "react-redux";
import injectSheet from "react-jss";
import PropTypes from "prop-types";
import AdSense from 'react-adsense';
import Masonary from "../components/Product/Masonary";

import { setNavigatorPosition, setNavigatorShape } from "../state/store";
import { featureNavigator } from "../utils/shared";
import Seo from "../components/Seo";
import Main from "../components/Main";
import Article from "../components/Main/Article";

const styles = theme => ({
  showcase: {}
});

class Index extends React.Component {
  featureNavigator = featureNavigator.bind(this);

  componentWillMount() {
    if (this.props.navigatorPosition !== "is-featured") {
      this.props.setNavigatorPosition("is-featured");
    }
  }

  componentDidMount() {
    const script = document.createElement("script");

    script.src = "//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=519fc41f-0653-4509-90ef-924c14ee1371";
    script.async = true;

    document.body.appendChild(script);
  }

  render() {
    const { data, classes } = this.props;
    const facebook = (((data || {}).site || {}).siteMetadata || {}).facebook;

    return (
      <Main>
        <Article>
          <div id="amzn-assoc-ad-519fc41f-0653-4509-90ef-924c14ee1371"></div>
          <Seo facebook={facebook} />
          <Masonary
            className={classes.showcase}
            products={data.allProduct.edges.map(edge => edge.node)}
          />
        </Article>
      </Main>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  navigatorPosition: PropTypes.string.isRequired,
  setNavigatorPosition: PropTypes.func.isRequired,
  isWideScreen: PropTypes.bool.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    navigatorPosition: state.navigatorPosition,
    isWideScreen: state.isWideScreen
  };
};

const mapDispatchToProps = {
  setNavigatorPosition,
  setNavigatorShape
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectSheet(styles)(Index));

//eslint-disable-next-line no-undef
export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        facebook {
          appId
        }
      }
    }

    allProduct {
      edges {
        node {
          id
          title
          excerpt
          fields{
            formattedPrice
            thumbnailUrl
            pageUrl   
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js